export default __webpack_public_path__ + "static/media/casal_9.6db7ec40.jpg";